import React from 'react'

import { useAppInfo } from 'hooks/useAppInfo'
import { UsBranchSupportTemplate } from 'templates/UsBranchSupportTemplate'

export const UbSupport = () => {
  const {
    languageDictionary: { support: dictionary },
  } = useAppInfo()

  return <UsBranchSupportTemplate dictionary={dictionary} />
}
